import { deleteInventoryItem } from "../../api/inventoryService";

export const useDeleteInventoryItem = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInventoryItem(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete inventory item:", error);
            throw error;
        }
    };

    return { remove };
};